//--------------------------------
// build reaction selection update
//--------------------------------
export default function buildReactionSelectionUpdate({
  combatant = null,
  selectedReaction = null,
  viewRound = 0,
  slot = '',
  slotSlug = '',
} = {}) {
  if (!combatant?.id || !selectedReaction?.id) {
    return null
  }

  const clickedSlot = String(slot || '')
  const clickedSlotNumber = Number(clickedSlot.replace('cr', ''))
  const currentReactionCount = Number(combatant.reaction_count || 0)
  const isExistingReaction = String(slotSlug || '').trim() !== ''
  const crNum =
    isExistingReaction && Number.isFinite(clickedSlotNumber) && clickedSlotNumber > 0
      ? clickedSlotNumber
      : currentReactionCount + 1

  return {
    crNum,
    slotField: 'cr' + crNum,
    slotNameField: 'cr_name' + crNum,
    reactionCount: Math.max(currentReactionCount, crNum),
    payload: {
      round: viewRound,
      number: crNum,
      combatant: combatant.id,
      reaction: selectedReaction.id,
      slug: slotSlug,
    },
  }
}
